import React, { useState } from "react";
import "./App.css";

export default function App() {
  const [showShop, setShowShop] = useState(false);

  const products = [
    {
      id: 1,
      title: "Sunset Over Water",
      price: 120,
      image:
        "https://images.unsplash.com/photo-1504208434309-cb69f4fe52b0?q=80&w=1600&auto=format&fit=crop",
      type: "Canvas Print",
    },
    {
      id: 2,
      title: "Mountain Glow",
      price: 150,
      image:
        "https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=1600&auto=format&fit=crop",
      type: "Acrylic Print",
    },
    {
      id: 3,
      title: "Forest Reflections",
      price: 95,
      image:
        "https://images.unsplash.com/photo-1511765224389-37f0e77cf0eb?q=80&w=1600&auto=format&fit=crop",
      type: "Metal Print",
    },
    {
      id: 4,
      title: "Urban Nights",
      price: 130,
      image:
        "https://images.unsplash.com/photo-1512428559087-560fa5ceab42?q=80&w=1600&auto=format&fit=crop",
      type: "Canvas Print",
    },
  ];

  const [cart, setCart] = useState([]);

  const addToCart = (item) => {
    setCart([...cart, item]);
  };

  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #1a1a1a, #2c2c2c)",
        color: "#f3e7d3",
        minHeight: "100vh",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* Navbar */}
      <header
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "#1f1f1f",
          borderBottom: "1px solid #3a3a3a",
          padding: "1rem 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <h1 style={{ fontWeight: "700", letterSpacing: "1px" }}>
          Wild Moments Photography
        </h1>
        <nav style={{ display: "flex", gap: "1.5rem" }}>
          <button
            onClick={() => setShowShop(false)}
            style={{
              background: "none",
              border: "none",
              color: "#f3e7d3",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Home
          </button>
          <button
            onClick={() => setShowShop(true)}
            style={{
              background: "none",
              border: "none",
              color: "#f3e7d3",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Shop
          </button>
        </nav>
      </header>

      {/* Home Page */}
      {!showShop && (
        <>
          <section
            style={{
              textAlign: "center",
              padding: "5rem 1rem",
              backgroundImage:
                "url('https://images.unsplash.com/photo-1501785888041-af3ef285b470?q=80&w=1600&auto=format&fit=crop')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "#fff",
              position: "relative",
            }}
          >
            <div
              style={{
                backgroundColor: "rgba(0,0,0,0.5)",
                padding: "3rem",
                borderRadius: "12px",
                display: "inline-block",
              }}
            >
              <h2 style={{ fontSize: "3rem", fontWeight: "800" }}>
                Capturing the Wild.
              </h2>
              <p style={{ maxWidth: "600px", margin: "1rem auto", fontSize: "1.2rem" }}>
                Discover stunning wildlife and landscapes — from serene forests
                to fiery sunsets. Each photo is a story frozen in time.
              </p>
              <button
                onClick={() => setShowShop(true)}
                style={{
                  marginTop: "1rem",
                  padding: "0.8rem 2rem",
                  background: "#d7a95b",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Explore Prints
              </button>
            </div>
          </section>

          <section style={{ padding: "4rem 2rem", textAlign: "center" }}>
            <h3 style={{ fontSize: "2rem", fontWeight: "700", marginBottom: "2rem" }}>
              Featured Work
            </h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "1.5rem",
                maxWidth: "1000px",
                margin: "0 auto",
              }}
            >
              {products.slice(0, 3).map((p) => (
                <div
                  key={p.id}
                  style={{
                    background: "#2a2a2a",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.4)",
                  }}
                >
                  <img
                    src={p.image}
                    alt={p.title}
                    style={{ width: "100%", height: "250px", objectFit: "cover" }}
                  />
                  <div style={{ padding: "1rem" }}>
                    <h4 style={{ marginBottom: "0.5rem" }}>{p.title}</h4>
                    <p style={{ color: "#d7a95b" }}>{p.type}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section style={{ padding: "4rem 2rem", maxWidth: "800px", margin: "0 auto" }}>
            <h3 style={{ fontSize: "2rem", fontWeight: "700" }}>About the Artist</h3>
            <p style={{ marginTop: "1rem", lineHeight: "1.8", fontSize: "1.1rem" }}>
              I’m Mark, a nature and wildlife photographer capturing fleeting
              moments that showcase the wild beauty of our planet. My mission is
              to bring the serenity of untouched landscapes and the wonder of
              wildlife into your space — one print at a time.
            </p>
          </section>

          <section
            style={{
              padding: "4rem 2rem",
              textAlign: "center",
              background: "#1f1f1f",
            }}
          >
            <h3 style={{ fontSize: "2rem", fontWeight: "700" }}>Contact</h3>
            <p style={{ margin: "1rem 0" }}>Reach out for custom orders or commissions.</p>
            <p>
              📧 <a href="mailto:hello@wildmoments.com">hello@wildmoments.com</a>
            </p>
          </section>
        </>
      )}

      {/* Shop Page */}
      {showShop && (
        <section style={{ padding: "4rem 2rem", maxWidth: "1100px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "2.5rem", fontWeight: "700", marginBottom: "2rem" }}>
            Available Prints
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "2rem",
            }}
          >
            {products.map((p) => (
              <div
                key={p.id}
                style={{
                  background: "#2a2a2a",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.4)",
                }}
              >
                <img
                  src={p.image}
                  alt={p.title}
                  style={{ width: "100%", height: "250px", objectFit: "cover" }}
                />
                <div style={{ padding: "1rem" }}>
                  <h4 style={{ marginBottom: "0.5rem" }}>{p.title}</h4>
                  <p style={{ color: "#d7a95b" }}>{p.type}</p>
                  <p style={{ fontWeight: "600", fontSize: "1.1rem" }}>${p.price}</p>
                  <button
                    onClick={() => addToCart(p)}
                    style={{
                      marginTop: "0.8rem",
                      width: "100%",
                      padding: "0.7rem",
                      border: "none",
                      borderRadius: "6px",
                      background: "#d7a95b",
                      color: "#000",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            ))}
          </div>

          {cart.length > 0 && (
            <div
              style={{
                marginTop: "3rem",
                padding: "2rem",
                background: "#1f1f1f",
                borderRadius: "12px",
              }}
            >
              <h3>Your Cart</h3>
              {cart.map((item, i) => (
                <p key={i}>
                  {item.title} - ${item.price}
                </p>
              ))}
              <p style={{ marginTop: "1rem", fontWeight: "700" }}>
                Total: ${cart.reduce((sum, i) => sum + i.price, 0)}
              </p>
            </div>
          )}
        </section>
      )}

      {/* Footer */}
      <footer
        style={{
          borderTop: "1px solid #3a3a3a",
          padding: "2rem",
          textAlign: "center",
          color: "#d7a95b",
          fontSize: "0.9rem",
        }}
      >
        © {new Date().getFullYear()} Wild Moments Photography — All Rights Reserved
      </footer>
    </div>
  );
}
